import { useState } from 'react';
import TourMachine from './TourMachine';

export default function TourSite(props) {

  const [chosenMachine, setchoseMachine] = useState();
  const [chosenMachineType, setchoseMachineType] = useState();
  const [showingPackList, setShowPackList] = useState();
  const [packListContent, setPackListContent] = useState('');

  let categoryNames = {
    '291815015046972850': 'Heiß',
    '291815120424666548': 'Kalt',
    '291815240398538165': 'Snack',
    '291815298430928310': 'Frisch',
    '291815398993561015': 'Pfand',
    '291815481914951096': 'Eis',
    '291815547329316281': 'Sonstiges',
  };

  const chooseMachine = (machine) => {
    setchoseMachine(machine);
    Object.entries(props.machineTypes).forEach(([key, machineType]) => {
      if (key == machine.machine_type_id) {
        setchoseMachineType(machineType);
      }
    });
  }

  const clearMachine = (checkAllDone = false) => {
    //check if all machines are done
    if (checkAllDone) {
      let allDone = true;
      Object.entries(props.site.machines).forEach(([key, machine]) => {
        if (machine.allServicesDone == false) allDone = false;
      });
      props.site.allMachinesDone = allDone;
      if (allDone) {
        props.clearSite();
        return;
      }
    }
    setchoseMachine(null);
  }

  const setMachineExtraData = (machineData) => {
    if (chosenMachine == null) return;
    Object.entries(props.site.machines).forEach(([key, machine]) => {
      if (machine == chosenMachine) {
        props.site.machines[key] = machineData;
      }
    });
  }

  const sorter = (sortBy) => (a, b) => a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;


  const getTradeUnits = (missingAmount, tradeUnitContent, tradeUnitWastage) => {
    let tradeUnits = 0;
    if (tradeUnitContent <= 1) return missingAmount;
    let tradeUnitThreshold = tradeUnitContent * (100.0 - tradeUnitWastage) / 100.0;
    if (missingAmount < tradeUnitThreshold) return tradeUnits;
    tradeUnits = Math.floor(missingAmount / tradeUnitContent);
    if (missingAmount - tradeUnits * tradeUnitContent > tradeUnitThreshold) tradeUnits++;
    return tradeUnits;
  }

  const showPackList = () => {
    setShowPackList(true);
    let siteProductData = {};
    Object.entries(props.site.machines).forEach(([key, machine]) => {
      if (machine.productData === null) return;
      Object.entries(machine.productData).forEach(([pkey, product]) => {
        if (siteProductData[product['category_id']] == undefined) {
          siteProductData[product['category_id']] = [];
        }
        if (siteProductData[product['category_id']][product['base_material_id']] == undefined) {
          siteProductData[product['category_id']][product['base_material_id']] = product;
        }
        siteProductData[product['category_id']][product['base_material_id']]['rounded_amount'] = 0;
      });
    });
    Object.entries(props.site.machines).forEach(([key, machine]) => {
      if (machine.productData === null) return;
      Object.entries(machine.productData).forEach(([pkey, product]) => {
        if (product['current_amount'] <= product['trade_unit_fill_threshold']) {
          siteProductData[product['category_id']][product['base_material_id']]['rounded_amount'] += getTradeUnits(product['max_amount'] - product['current_amount'], product['trade_unit_content'], product['trade_unit_wastage']) * product['trade_unit_content'];
        }
      });
    });
    let newContent = [];
    setPackListContent('');
    Object.entries(siteProductData).forEach(([productCategoryId, productCategoryData]) => {

      let productEntries = Object.values(productCategoryData);
      productEntries.sort(sorter('name'));
      let categoryItems = [];
      productEntries.forEach((product) => {
        if (product.rounded_amount == undefined || product.rounded_amount <= 0) return;
        categoryItems.push(<tr><td>{product.name}</td><td style={{ textAlign: 'right' }}>{Math.round(product.rounded_amount / product.trade_unit_content)}</td></tr>);
      });
      if (categoryItems.length > 0) {
        newContent.push(<tr className='blue'><td colSpan="2">{categoryNames[productCategoryId] ?? 'Unbekannt'}</td></tr>);
        newContent = newContent.concat(categoryItems);
      }
    });
    setPackListContent(newContent);
  }

  const hidePackList = () => {
    setShowPackList(false);
  }

  let content;
  if (showingPackList) {
    content =
      <div>
        <h3 className="ui inverted block header"><i className="chevron left icon" onClick={hidePackList}></i>Packliste {props.site.name}</h3>
        <table className="ui unstackable celled very compact single line table packlist">
          <thead>
            <tr><th colSpan="2">
              Produkte
            </th>
            </tr></thead>
          <tbody>
            {packListContent}
          </tbody>
        </table>
      </div>
  }
  else {
    if (chosenMachine == null) {
      const items = props.site.machines.map(machine => <div className="event" key={machine.id} onClick={() => chooseMachine(machine)}>
        <div className={(machine.allServicesDone ? "green" : "") + " label"} data-text={Object.keys(machine.services).length}></div>
        <div className="content">
          <div className="summary">
            <a className="header">{machine.serial_number}, {machine.device_number}</a>
            <div className="date">
              {new Date(machine.arrival_time).toLocaleTimeString()}
            </div>
          </div>
          <div className="meta">
            <a className="like">
              {machine.type_name}
            </a>
            {
              machine.building_floor == '' ? '' :
                <a className="like">
                  {machine.building_floor}
                </a>
            }
            {
              machine.building_room == '' ? '' :
                <a className="like">
                  {machine.building_room}
                </a>
            }
            {
              machine.missingCoinCount >= 25 ? <i className='coins red icon'></i> : ''
            }
          </div>
        </div>
      </div>);
      content = <div>
        <h3 className="ui inverted block header"><i className="chevron left icon" onClick={props.clearSite}></i>Standort {props.site.name}</h3>
        <a onClick={e => showPackList()}><i className='clipboard list icon'></i> Packliste</a><br />
        <div className='ui divider'></div>
        <div className="ui divided feed">{items}</div>
      </div>
    }
    else {
      content = <TourMachine machine={chosenMachine} machineType={chosenMachineType} clearMachine={clearMachine} setMachineExtraData={setMachineExtraData} setServiceQueue={props.setServiceQueue} spontaneous={false} userOptions={props.userOptions} />;
    }
  }

  return (
    <div>

      {content}
    </div>
  );
}